module.exports = __webpack_public_path__ + "static/media/campus_31.a167a3ec.png";